




















import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import { notify } from '@/web/utils/notify';

import CouponForm from '@/web/components/coupons/CouponForm.vue';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import { errorToMessage, scrollToFirstFormError } from '@/core/utils/errors';
import moment from 'moment';
import { ValidationObserver } from 'vee-validate';

interface LocalState {
  coupon: UpdateCouponRequest | null;
  inProgress: boolean;
  date: DatePicker;
}

export default Vue.extend({
  name: 'EditCoupon',
  mixins: [DirtyMixin],
  components: {
    TopNav,
    NavItem,
    CouponForm,
    ValidationObserver,
  },
  data(): LocalState {
    return {
      coupon: null,
      inProgress: false,
      date: {
        startDate: new Date(),
        endDate: new Date(),
      },
    };
  },
  computed: mapGetters({
    teacherCoupon: 'product/teacherCoupon',
  }),
  async mounted() {
    const id = parseInt(this.$route.params['id']);
    await this.$store.dispatch('product/getTeacherCouponDetail', id);
    this.coupon = cloneDeep(this.teacherCoupon);
  },
  methods: {
    navigateBack(): void {
      this.$router.back();
    },
    async update(): Promise<void> {
      if (this.inProgress) {
        return;
      }
      this.$refs.form.validate();
      if (this.$refs.form.flags.invalid) {
        scrollToFirstFormError();
        return;
      }
      this.inProgress = true;
      try {
        if (this.coupon) {
          this.coupon.redeem_start = moment(this.date.startDate).format(
            'YYYY-MM-DD'
          );
          this.coupon.redeem_end = moment(this.date.endDate).format(
            'YYYY-MM-DD'
          );
          this.coupon.products = this.coupon.products.map(p => p.id);
        }
        await this.$store.dispatch('product/updateCoupon', this.coupon);
        this.clearDirty();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('PRODUCTS.MODAL.COUPON_UPDATED_DESCRIPTION'),
        });
        this.navigateBack();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to create the coupon',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
  },
});
